import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-offline-dialog',
  templateUrl: './offline-dialog.component.html',
  styleUrls: ['./offline-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineDialogComponent {}
